import clsx from "clsx"
import { ReactNode } from "react"
type TTag = {
  isSelected: boolean
  tagTitle?: string
  onClick?: (args?: any) => void
  customNonSelectedStyle?: React.ComponentProps<"div">["className"]
  customSelectedStyle?: React.ComponentProps<"div">["className"]
  children?: ReactNode
}
const Tag: React.FC<TTag> = ({
  isSelected,
  tagTitle,
  onClick = () => {},
  customNonSelectedStyle,
  customSelectedStyle,
  children,
}) => {
  const nonSelectedStyle = clsx(
    "bg-[#7F7F7F66] border border-transparent text-[#FFFFFF80]",
    customNonSelectedStyle,
  )
  const selectedStyle = clsx(
    "border-[#FFFFFF33] border bg-[#C2C2C280] text-white",
    customSelectedStyle,
  )
  return (
    <div
      className={`text-xs sm:text-sm my-1 mx-1 min-w-fit place-content-center py-1 px-4  align-middle rounded-lg hover:cursor-pointer ${isSelected ? selectedStyle : nonSelectedStyle}`}
      onClick={onClick}
    >
      {tagTitle}
      {children}
    </div>
  )
}

export default Tag
